module.exports = __webpack_public_path__ + "static/media/card.ae85f3ba.svg";